import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AsyncSelect from 'react-select/lib/Async';
import { fetchPatientDetails } from '../queries';
import { displayError } from '../utilities';

export default class SearchPatientByMobile extends Component {
  state = {};

  fetchPatientList = async mobileno => {
    const mobile = `${mobileno}`.trim().slice(0, 10);

    if (mobile.length < 10) return;
    try {
      const res = await fetchPatientDetails({ mobile });
      const patients = res.data.getPatientDetails || [];
      const patientList = patients
        .filter(obj => !obj.isDeleted)
        .map(obj => ({
          label: `${obj.first_name} - ${obj.mpid}`,
          value: obj
        }));
      return patientList;
    } catch (err) {
      displayError(
        err.response.data
          ? err.response.data.error.message
          : 'Something went wrong!'
      );
    }
  };

  handleMobileNoChange = (inputData, { action }) => {
    const input = `${inputData}`.trim().replace(/\D/, '');

    if (input && input.length && input.length > 10) {
      this.setState({ value: input.slice(0, 10) });
    } else {
      this.setState({ value: input });
    }

    if (action !== 'input-change') return;
    this.props.onMobileNoChange(input);
  };

  render() {
    const { onChange } = this.props;
    return (
      <AsyncSelect
        cacheOptions
        inputValue={this.state.value}
        loadOptions={this.fetchPatientList}
        onChange={option => onChange(option.value)}
        onMobileNoChange={this.handleMobileNoChange}
        maxMenuHeight={200}
      />
    );
  }
}

SearchPatientByMobile.propTypes = {
  onChange: PropTypes.func,
  onMobileNoChange: PropTypes.func
};
